var _style, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOnFocus(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 20 20",
    style: {
      enableBackground: "new 0 0 20 20"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#C4C4C4;}\r\n\t.st1{fill:#616160;}\r\n\t.st2{fill:#FFFFFF;}\r\n\t.st3{fill:#C4C4C4;stroke:#616160;stroke-miterlimit:10;}\r\n\t.st4{fill:#FFFFFF;stroke:#616160;stroke-miterlimit:10;}\r\n\t.st5{fill:#616160;stroke:#616160;stroke-width:0.25;stroke-miterlimit:10;}\r\n\t.st6{fill:none;stroke:#616160;stroke-miterlimit:10;stroke-dasharray:2.0068,2.0068;}\r\n\t.st7{fill:#616160;stroke:#616160;stroke-miterlimit:10;}\r\n\t.st8{fill:none;stroke:#FFFFFF;stroke-miterlimit:10;}\r\n\t.st9{fill:none;stroke:#FFFFFF;stroke-width:2;stroke-miterlimit:10;}\r\n\t.st10{fill:#C4C4C4;stroke:#FFFFFF;stroke-miterlimit:10;}\r\n\t.st11{fill:none;stroke:#FFFFFF;stroke-miterlimit:10;stroke-dasharray:1.9724,1.9724;}\r\n\t.st12{fill:#FFFFFF;stroke:#FFFFFF;stroke-width:0.25;stroke-miterlimit:10;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M15.455,17.455H4.545c-1.105,0-2-0.895-2-2V4.545c0-1.105,0.895-2,2-2h10.91c1.105,0,2,0.895,2,2v10.91 C17.455,16.56,16.56,17.455,15.455,17.455z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M15.455,17.955H4.545c-1.378,0-2.5-1.121-2.5-2.5V4.545c0-1.378,1.122-2.5,2.5-2.5h10.91 c1.379,0,2.5,1.122,2.5,2.5v10.91C17.955,16.834,16.834,17.955,15.455,17.955z M4.545,3.045c-0.827,0-1.5,0.673-1.5,1.5v10.91 c0,0.827,0.673,1.5,1.5,1.5h10.91c0.827,0,1.5-0.673,1.5-1.5V4.545c0-0.827-0.673-1.5-1.5-1.5H4.545z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOnFocus);
export default __webpack_public_path__ + "static/media/_OnFocus.54f5bf0fb3562854840887a0d5e861e0.svg";
export { ForwardRef as ReactComponent };